import styled from '@emotion/styled';
import React from 'react';
import { theme } from 'styles/theme/theme';

export interface UDCardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const CardWrapper = styled.div<{ $clickable: boolean }>`
  background: ${theme.colors.SurfaceWhite};
  border: 1px solid ${theme.colors.DarkBlue100};
  border-radius: 8px;
  padding: 16px;
  ${({ $clickable }) =>
    $clickable &&
    `
    cursor: pointer;
    transition: border-color 0.15s ease;
    &:hover {
      border-color: #bdbdbd;
    }
  `}
`;

const UDCard: React.FC<UDCardProps> = ({ children, className, style, onClick }) => {
  return (
    <CardWrapper $clickable={!!onClick} className={className} style={style} onClick={onClick}>
      {children}
    </CardWrapper>
  );
};

export default UDCard;
